import Projects from "@/components/Projects";

export default function ProjectsPage() {
  return (
    <main className="bg-paper pt-16">
      <Projects />
    </main>
  );
}
